import * as React from 'react';
export const shinhyupSvg = React.forwardRef(function shinhyupSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0056A7',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M26.542 18.099c-1.152 2.98-3.075 3.818-3.075 3.818 5.67-5.983 2.205-12.884 2.205-12.884-.838-1.545.225-2.222.225-2.222-2.435.631-1.675 2.733-1.675 2.733 1.223 3.037.976 5.5.562 7.027l-.804-.47.01-.018s1.902-7.803-5.852-10.541V4.083h-1.642v9.67l7.61 4.518c-.137.293-.286.568-.44.832l-7.644-4.61-7.677 4.61a10.34 10.34 0 0 1-.44-.832l7.61-4.519V4.083h-1.637v1.47C6.13 8.292 8.031 16.095 8.031 16.095l.011.017-.804.47c-.414-1.527-.661-3.99.562-7.027 0 0 .76-2.101-1.675-2.733 0 0 1.063.672.226 2.222 0 0-3.461 6.896 2.204 12.884 0 0-1.929-.844-3.075-3.818 0 0-.65-1.453-2.48-1.137 0 0 .689.328 1.091 1.642 0 0 1.648 5.455 7.996 6.287v3.015h3.12v-4.439s-3.313-.028-5.837-2.922l.783-.477c.149.144 2.546 2.464 5.825 2.521h.039c3.279-.063 5.681-2.377 5.825-2.52l.782.476c-2.524 2.9-5.836 2.922-5.836 2.922v4.439h3.12v-3.015c6.353-.832 7.995-6.287 7.995-6.287.403-1.314 1.097-1.642 1.097-1.642-1.824-.316-2.48 1.137-2.48 1.137l.022-.011Zm-4.067-2.877h-.005l-4.293-2.498-.022-5.35h.022s5.174 1.463 4.298 7.848Zm-8.624-7.849h.022l-.022 5.351-4.293 2.504h-.006c-.876-6.39 4.299-7.855 4.299-7.855Zm2.177 9.14 4.282 2.608-.04-.018c-1.531 1.258-2.991 1.677-4.253 1.677s-2.723-.42-4.255-1.677l-.038.023 4.304-2.612Z',
      fill: '#fff',
    }),
  );
});
shinhyupSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var shinhyup = {
  category: 'brand',
  colorable: false,
  name: 'shinhyup',
  svg: shinhyupSvg,
};
